import '../styles/style.css';
import '../styles/mobile-styles.css';
import './Home.css'
import { Link } from 'react-router-dom'
import Header from '../components/Layout/Header.jsx';
import Footer from '../components/Layout/Footer.jsx';
import CartDrawer from '../components/Cart/CartDrawer.jsx';

export default function Home() {
  
  const featuredCards = [
    {
      id: "BirthdayTraditional",
      title: "Birthday Traditional",
      price: "$4.99",
      image: "/cardImages/BirthdayTraditional.jpg",
      description: "A classic birthday card with a personalized AR surprise."
    },
    {
      id: "BirthdaySong",
      title: "Birthday Song",
      price: "$5.99",
      image: "/cardImages/BirthdaySong.jpg",
      description: "Send a musical AR moment with a personalized message."
    },
    {
      id: "Bundle5Pack",
      title: "5 Card Starter Pack",
      price: "$10.00",
      image: "/cardImages/BirthdayTraditional.jpg",
      description: "A simple starter bundle for trying multiple WildCards."
    }
  ];

  return (
 <div className="home-page">
      <Header />

      <main className="home-main">
        {/* HERO */}
        <section className="hero-banner">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/wildcard-hero.mp4" type="video/mp4" />
          </video>

          <div className="hero-overlay" />

          <div className="hero-content">
            <p className="hero-kicker">Personalized AR Greeting Cards</p>
            <h1>Classic greeting cards <br/> with a digital twist.</h1>
            <p className="hero-subtext">
              No download. No login. Instant Results.
            </p>

            <div className="hero-buttons">
              <Link to="/shop" className="hero-btn primary">
                Shop Now
              </Link>
              <Link to="/how-it-works" className="hero-btn secondary">
                How It Works
              </Link>
            </div>
          </div>
        </section>

        {/* INTRO / PRODUCT EXPLAINER */}
        <section className="intro-section">
          <div className="section-inner">
            <p className="section-label">What is a WildCard?</p>
            <h2>A greeting card built for the digital generation.</h2>
            <p className="section-text">
              WildCard combines the classic joy of recieving a physical greeting card 
              with a customized AR experience that launches instantly from a QR code. 
              No app. No download. Instant results. Just scan, tap, and enjoy.
            </p>
          </div>
        </section>

        {/* 3 COLUMN INFO */}
        <section className="info-grid-section">
          <div className="section-inner">
            <div className="info-grid">
              <div className="info-card">
                <h3>Personalize It</h3>
                <p>
                  Add a recipient name, create a custom video, or choose from themed AR
                  experiences and card styles.
                </p>
              </div>

              <div className="info-card">
                <h3>Scan & Enjoy</h3>
                <p>
                  The recipient scans the QR code which instantly launches the AR
                  experience right in their phone's browser.
                </p>
              </div>

              <div className="info-card">
                <h3>E-Mail or Print</h3>
                <p>
                  Send your WildCard directly in an Email or Print and share your WildCard the classic way.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHY SECTION */}
        <section className="why-section">
          <div className="section-inner narrow">
            <p className="section-label">Why WildCard?</p>
            <h2>More memorable than a text. More fun than a standard card.</h2>
            <p className="section-text">
              A WildCard feels physical and personal, but also interactive and modern.
              It is a simple way to quickly send someone a surprise.
            </p>

            <ul className="why-list">
              <li>No app. No download.</li>
              <li>Works instantly from any phone camera.</li>
              <li>Customize with personalized names, videos, and experiences. </li>
              <li>Instant delivery or printable card options.</li>
              <li>Great for birthdays, holidays, gifts, and special moments</li>
              <li>Scan. Tap. Enjoy.</li>
            </ul>
          </div>
        </section>

        {/* FEATURED CARDS */}
        <section className="featured-section">
          <div className="section-inner">
            <div className="featured-header">
              <p className="section-label">Featured Cards</p>
              <h2>Start with a favorite.</h2>
            </div>

            <div className="featured-grid">
              {featuredCards.map((card) => (
                <div className="featured-card" key={card.id}>
                  <img src={card.image} alt={card.title} className="featured-image" />
                  <div className="featured-body">
                    <h3>{card.title}</h3>
                    <p className="featured-price">{card.price}</p>
                    <p>{card.description}</p>
                    <Link to="/shop" className="featured-link">
                      Shop This Style
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bottom-cta">
          <div className="section-inner narrow center">
            <h2>Ready to send something people will actually remember?</h2>
            <p>
              Shop personalized AR greeting cards and create a surprise worth scanning.
            </p>
            <Link to="/shop" className="hero-btn primary">
              Shop Now
            </Link>
          </div>
        </section>
      </main>
      <CartDrawer />
      <Footer />
    </div>
  );
}
